import { render, staticRenderFns } from "./ticketMng.vue?vue&type=template&id=479f64e1&scoped=true"
import script from "./ticketMng.vue?vue&type=script&lang=js"
export * from "./ticketMng.vue?vue&type=script&lang=js"
import style0 from "./ticketMng.vue?vue&type=style&index=0&id=479f64e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f64e1",
  null
  
)

export default component.exports